import { render } from "./processWizard.vue?vue&type=template&id=4a2600a8&scoped=true&lang=true"
import script from "./processWizard.vue?vue&type=script&lang=js"
export * from "./processWizard.vue?vue&type=script&lang=js"

import "./processWizard.vue?vue&type=style&index=0&id=4a2600a8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2600a8"]])

export default __exports__